"use client";

import { forwardRef } from "react";
import { useRouter } from "next/navigation";
import { cn } from "~/lib/utils";
import { ArrowLeftIcon } from "~/components/icons";

export interface BackButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
}

const BackButton = forwardRef<HTMLButtonElement, BackButtonProps>(
  ({ className, href, onClick, children = "Back", ...props }, ref) => {
    const router = useRouter();

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (onClick) {
        onClick(e);
      } else if (href) {
        router.push(href);
      } else {
        router.back();
      }
    };

    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          "flex h-8 items-center justify-center gap-2 rounded border border-[rgba(0,78,154,0.47)] px-3 text-sm font-semibold leading-5 text-[rgba(0,50,97,0.7)] transition-colors hover:bg-[rgba(0,85,199,0.04)] cursor-pointer",
          className
        )}
        onClick={handleClick}
        {...props}
      >
        <ArrowLeftIcon className="h-4 w-4" />
        {children}
      </button>
    );
  }
);

BackButton.displayName = "BackButton";

export { BackButton };

